
var mode = process.env.REACT_APP_ENV || 'production';

var LocalKeys = {
    API_URL                 : 'http://localhost:4040/v4/app',
    //AUTH_API_URL            : 'https://api.myoptimity.com/parse/apps/',
    AUTH_API_URL            : 'http://localhost:1337/apps/',
    GA_TRACKING_ID          : 'UA-111438927-4',
    GOOGLE_CLIENT_KEY       : '647187018277-ke5354c9ujr6lrdm4cceurrktgt1ns3n.apps.googleusercontent.com',
    GOOGLE_REDIRECT_URI     : window.location.protocol+'//'+window.location.host+'/oauth2callback.html?dev=true&auth=google',
    VALIDIC_REDIRECT_URI    : window.location.protocol+'//'+window.location.host+'/oauth2callback.html?auth=validic',
    SCOPES_CAL              : ["https://www.googleapis.com/auth/calendar.readonly"],
    SCOPES_CAL_V2           : ["https://www.googleapis.com/auth/calendar"],
    SCOPES_FIT              : ["https://www.googleapis.com/auth/fitness.activity.read"],
    SCOPES_GOOGLE_PEOPLE    : ["https://www.googleapis.com/auth/contacts.readonly"],
    LINKEDIN_CLIENT_KEY     : '77x5e1pla4l35x',
    LINKEDIN_REDIRECT_URI   : window.location.protocol+'//'+window.location.host+'/oauth2callback.html?auth=linkedin',
    FACEBOOK_CLIENT_KEY     : '1693867990835396',
    FACEBOOK_REDIRECT_URI   : window.location.protocol+'//'+window.location.host+'/oauth2callback.html?auth=facebook',
}

var DevKeys = {
    API_URL                 : 'https://dev-rest.myoptimity.com/v4/app',
    AUTH_API_URL            : 'https://api.myoptimity.com/parse/apps/',
    GA_TRACKING_ID          : 'UA-111438927-4',
    GOOGLE_CLIENT_KEY       : '647187018277-ke5354c9ujr6lrdm4cceurrktgt1ns3n.apps.googleusercontent.com',
    GOOGLE_REDIRECT_URI     : window.location.protocol+'//'+window.location.host+'/oauth2callback.html?dev=true&auth=google',
    VALIDIC_REDIRECT_URI    : window.location.protocol+'//'+window.location.host+'/oauth2callback.html?auth=validic',
    SCOPES_CAL              : ["https://www.googleapis.com/auth/calendar.readonly"],
    SCOPES_CAL_V2           : ["https://www.googleapis.com/auth/calendar"],
    SCOPES_FIT              : ["https://www.googleapis.com/auth/fitness.activity.read"],
    SCOPES_GOOGLE_PEOPLE    : ["https://www.googleapis.com/auth/contacts.readonly"],
    LINKEDIN_CLIENT_KEY     : '77x5e1pla4l35x',
    LINKEDIN_REDIRECT_URI   : window.location.protocol+'//'+window.location.host+'/oauth2callback.html?auth=linkedin',
    FACEBOOK_CLIENT_KEY     : '1693867990835396',
    FACEBOOK_REDIRECT_URI   : window.location.protocol+'//'+window.location.host+'/oauth2callback.html?auth=facebook',
}

var ProdKeys = {
    API_URL                 : 'https://rest.myoptimity.com/v4/app',
    AUTH_API_URL            : 'https://auth.myoptimity.com/apps/',
    GA_TRACKING_ID          : 'UA-111438927-1',
    GOOGLE_CLIENT_KEY       : '647187018277-ke5354c9ujr6lrdm4cceurrktgt1ns3n.apps.googleusercontent.com',
    GOOGLE_REDIRECT_URI     : window.location.protocol+'//'+window.location.host+'/oauth2callback.html?auth=google',
    VALIDIC_REDIRECT_URI    : window.location.protocol+'//'+window.location.host+'/oauth2callback.html?auth=validic',
    SCOPES_CAL              : ["https://www.googleapis.com/auth/calendar.readonly"],
    SCOPES_CAL_V2           : ["https://www.googleapis.com/auth/calendar"],
    SCOPES_FIT              : ["https://www.googleapis.com/auth/fitness.activity.read"],
    SCOPES_GOOGLE_PEOPLE    : ["https://www.googleapis.com/auth/contacts.readonly"],
    LINKEDIN_CLIENT_KEY     : '77x5e1pla4l35x',
    LINKEDIN_REDIRECT_URI   : window.location.protocol+'//'+window.location.host+'/oauth2callback.html?auth=linkedin',
    FACEBOOK_CLIENT_KEY     : '1693867990835396',
    FACEBOOK_REDIRECT_URI   : window.location.protocol+'//'+window.location.host+'/oauth2callback.html?auth=facebook',
};



var Keys = null;
switch(mode) {
    case 'local':
        Keys = LocalKeys; 
    break;
    case 'dev':
        Keys = DevKeys; 
    break;
    case 'production':
        Keys = ProdKeys; 
    break;
    default: 
        Keys = DevKeys;
}


export default Keys;



// WEBPACK FOOTER //
// ./src/keys/keys.js